// bint
export const finceOriginalOptions = [
  {
    key: 'id',
    name: '批量付款ID',
  },
  {
    key: 'state',
    name: '批量付款状态',
  },
  {
    key: 'gmtCreate',
    name: '创建时间',
  },
  {
    key: 'completeTime',
    name: '完成时间',
  },
  {
    key: 'discardTime',
    name: '作废时间',
  },
  {
    key: 'amount',
    name: '付款金额',
  },
  {
    key: 'customerName',
    name: '收款方',
  },
  {
    key: 'customerType',
    name: '收款方类型',
  },
  {
    key: 'remarks',
    name: '备注',
  },
]

// fince
export const finceCommonOriginalOptions = [
  {
    key: 'customerTypeName',
    name: '付款方类型',
  },
  {
    key: 'customerName',
    name: '付款方',
  },
  {
    key: 'completeTime',
    name: '收款单完成时间',
  },
  {
    key: 'remarks',
    name: '备注',
  },
  {
    key: 'attachment',
    name: '收款凭证',
  },
]

// approval
export const approvalOriginalOptions = [
  {
    key: 'customerTypeName',
    name: '付款方类型',
  },
  {
    key: 'attachment',
    name: '收款凭证',
  },
  {
    key: 'customerName',
    name: '付款方',
  },
  {
    key: 'remarks',
    name: '备注',
  },
  {
    key: 'completeTime',
    name: '收款单完成时间',
    alone: true,
  },
]
